var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./CategoryItem.module.scss";
import { getSettings } from "../../constants/setting";
import { isLanguageRTL } from "../../../../constants";
var CategoryItem = function (props) {
    var text = props.text, onChange = props.onChange;
    var language = getSettings().language;
    var onCategoryButtonClick = function () {
        onChange(text);
    };
    return _jsx("div", __assign({ className: "".concat(styles.categoryItem, " ").concat(isLanguageRTL(language) && styles.rtl) }, { children: _jsx("button", __assign({ className: styles.btn, onClick: onCategoryButtonClick }, { children: text })) }));
};
export default CategoryItem;
